(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product_faq"] && !Shopify.designMode) return;
  try {
    (function () {
    function initFaqBlock(item) {
      var btn    = item.querySelector('.faq-question');
      var answer = item.querySelector('.faq-answer');
      if (!btn || !answer) return;

      btn.addEventListener('click', function () {
        var isOpen = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
        if (isOpen) {
          answer.setAttribute('hidden', '');
        } else {
          answer.removeAttribute('hidden');
        }
      });
    }

    function initAll() {
      document.querySelectorAll('.faq-item').forEach(function (item) {
        if (!item.dataset.faqInit) {
          item.dataset.faqInit = '1';
          initFaqBlock(item);
        }
      });
    }

    document.addEventListener('DOMContentLoaded', initAll);
    document.addEventListener('shopify:block:load',   initAll);
    document.addEventListener('shopify:section:load', initAll);
    if (document.readyState !== 'loading') initAll();
  })();
  } catch(e) { console.error(e); }
})();

})();
